module.exports = __webpack_public_path__ + "img/youtube.ce48d4ad.svg";